<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icongangwei1"></i>
      {{ id ? '编辑实习岗位' : '发布实习岗位' }}
    </div>
    <div class="padding-sm">
      <el-form :model="practiceForm" :rules="rules" ref="practiceForm" label-width="130px">
        <el-form-item label="实习岗位名称" prop="sx_name">
          <el-input v-model="practiceForm.sx_name" placeholder="请输入实习岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="实习地点" prop="address">
          <el-input v-model="practiceForm.address" placeholder="请输入实习地点"></el-input>
        </el-form-item>
        <el-form-item label="招募名额" prop="stu_num">
          <el-input type="number" v-model.number="practiceForm.stu_num" placeholder="请输入招募名额"></el-input>
        </el-form-item>
        <el-form-item label="实习时间" prop="shixi_time">
          <el-input v-model="practiceForm.shixi_time" placeholder="请输入实习时间"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="8" v-if="!practiceForm.no_money">
            <el-form-item label="薪资范围" prop="min_money">
              <el-input type="number" v-model="practiceForm.min_money" placeholder="请输入薪资范围最小值">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!practiceForm.no_money">
            <el-form-item label="" prop="max_money" label-width="1">
              <el-input type="number" v-model="practiceForm.max_money" placeholder="请输入薪资范围最大值">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="practiceForm.no_money?'薪资范围':''" prop="no_money"
                          :label-width="practiceForm.no_money?'130px':'1px'">
              <el-checkbox v-model="practiceForm.no_money">无薪资</el-checkbox>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item label="报名截止时间" prop="end_time">
          <el-date-picker
              style="width: 100%"
              v-model="practiceForm.end_time"
              :picker-options="pickerOptions"
              type="date"
              placeholder="请选择报名截止时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="岗位职责" prop="zhize">
          <el-input type="textarea" rows="5" v-model="practiceForm.zhize" placeholder="请输入岗位职责"></el-input>
        </el-form-item>
        <el-form-item label="入职条件" prop="tiaojian">
          <el-input type="textarea" rows="5" v-model="practiceForm.tiaojian" placeholder="请输入入职条件"></el-input>
        </el-form-item>
        <el-form-item label="入职要求" prop="yaoqiu">
          <el-input type="textarea" rows="5" v-model="practiceForm.yaoqiu" placeholder="请输入入职要求"></el-input>
        </el-form-item>
        <el-form-item label="其他补贴待遇" prop="daiyu">
          <el-input type="textarea" rows="5" v-model="practiceForm.daiyu" placeholder="请输入其他补贴待遇"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" rows="5" v-model="practiceForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around">
          <el-button class="padding-lr-xl submit-btn" type="primary" @click="submitForm('practiceForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {stationAdd, station} from "@/api/practiceBase";

export default {
  name: "practiceBaseEdit",
  data() {
    return {
      id: '',
      practiceForm: {
        sx_name: '',
        address: '',
        stu_num: '',
        shixi_time: '',
        end_time: '',
        min_money: '',
        max_money: '',
        no_money: false,
        zhize: '',
        tiaojian: '',
        yaoqiu: '',
        daiyu: '',
        remark: ''
      },
      rules: {
        sx_name: [{required: true, message: '请输入实习岗位名称', trigger: 'blur'},],
        address: [{required: true, message: '请输入实习地点', trigger: 'blur'},],
        stu_num: [{required: true, message: '请输入招募名额', trigger: 'blur'},],
        shixi_time: [{required: true, message: '请输入实习时间', trigger: 'blur'},],
        end_time: [{required: true, message: '请选择报名截止时间', trigger: 'blur'},],
        min_money: [{required: true, message: '请输入薪资范围最小值', trigger: 'blur'},],
        max_money: [{required: true, message: '请输入薪资范围最大值', trigger: 'blur'},],
        zhize: [{required: true, message: '请输入岗位职责', trigger: 'blur'},],
        tiaojian: [{required: true, message: '请输入入职条件', trigger: 'blur'},],
        yaoqiu: [{required: true, message: '请输入入职要求', trigger: 'blur'},],
        daiyu: [{required: true, message: '请输入其他补贴待遇', trigger: 'blur'},],
      },
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    }
  },
  created() {
    this.$emit(
        "setIndex",
        '/practiceBase/practiceBaseList',
        "当前位置：通知管理 - " + this.id ? '编辑实习岗位' : '发布实习岗位',
        true
    );

    if (this.$route.query.id) this.id = this.$route.query.id, this.getDetail()
  },
  methods: {
    async getDetail() {
      let _data = await station(this.$route.query.id)
      this.practiceForm = {
        sx_name: _data.data.sx_name,
        address: _data.data.address,
        stu_num: _data.data.stu_num,
        shixi_time: _data.data.shixi_time,
        end_time: new Date(_data.data.end_time),
        zhize: _data.data.zhize,
        tiaojian: _data.data.tiaojian,
        yaoqiu: _data.data.yaoqiu,
        daiyu: _data.data.daiyu,
        remark: _data.data.remark,
        min_money: Number(_data.data.salary_min),
        max_money: Number(_data.data.salary_max),
        no_money:  Number(_data.data.salary_min) === 0 &&  Number(_data.data.salary_max) === 0
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureEdit()
        }
      });
    },
    async sureEdit() {
      let _state = await stationAdd(
          this.practiceForm.sx_name,
          this.practiceForm.address,
          this.practiceForm.stu_num,
          this.practiceForm.shixi_time,
          this.$tools.ZHDate(new Date(this.practiceForm.end_time), 3),
          this.practiceForm.zhize,
          this.practiceForm.tiaojian,
          this.practiceForm.yaoqiu,
          this.practiceForm.daiyu,
          this.practiceForm.remark,
          this.practiceForm.no_money ? 0 : this.practiceForm.min_money,
          this.practiceForm.no_money ? 0 : this.practiceForm.max_money,
          this.id
      )
      this.$message.success(_state.msg)
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">

</style>